
import {
  defineComponent,
  getCurrentInstance,
  onUnmounted,
  onMounted,
  ref,
} from "vue";
import VideoPlayer from './components/video.vue'
import { getMetaInfo, header, extractTitleFromMetaInfo, getDefaultTitle, getLdJson } from '@/common/seo'
import { setCommonParamsCookiesInServer } from '@/common/common-params';

export default defineComponent({
  components: {
      VideoPlayer,
  },
  setup(props, ctx) {
      const { proxy } = getCurrentInstance() as any;

      const downloadModel = ref(false);

      const photoList = ref([]);

      const handleShowModal = () => {
          downloadModel.value = true
      }

      const hideDownloadModel = () => {
          downloadModel.value = false;
      };
      return {
          downloadModel,
          handleShowModal,
          hideDownloadModel,
          photoList
      };
  },
  async asyncData(ctx:any) {
      let photoList = []
      let seoData = []
      let metaInfoData = []
      let title = getDefaultTitle(ctx)
      let showFeed = false
      const { query } = ctx
      if ((process as any).server) {
          setCommonParamsCookiesInServer({ bucket: ctx.store.state.startup.bucket, host: ctx.req.headers.host, ctx, countryInfo: ctx.store.state.startup.countryInfo })
          try {
              const { photoId } = ctx.route?.query
              const realPhotoId = ctx?.route?.params?.photoId || photoId
              showFeed = query.pwa_source === 'share'
              const url = `https://${ctx?.req?.headers?.host}${ctx?.route?.path}` || ''

              // 获取google ldjson 标签
              let seoPromise = getLdJson({ ctx, params: { url } })
              // 获取meta info
              let metaInfoPromise = getMetaInfo({ ctx, params: { url, locale: ctx.req.headers['accept-language'] } })

              let photoPromise = ctx.$axios.$$post('overseaAPI::/rest/o/w/pc/photo/get', { photo_id: realPhotoId })
              let [photoRes, seoRes, metaInfoRes] = await Promise.all([photoPromise, seoPromise, metaInfoPromise])

              if (photoRes.result === 1) {
                  photoList = photoRes.feeds
              }

              if (seoRes.status === 200) {
                  seoData = seoRes.data
              }

              if (metaInfoRes.status === 200) {
                  metaInfoData = metaInfoRes.data
                  title = extractTitleFromMetaInfo({ ctx, metaInfoData})
              }

          } catch (error) {
              console.log(error)
          }

      } else {
            const { feeds, result } = await ctx.$axios.$$post('overseaAPI::/rest/o/w/pc/photo/get', { photo_id: ctx.route.params.photoId })
            if(result === 1) {
                photoList = feeds
            }
      }


      return {
          photoList,
          showFeed,
          seoData,
          metaInfoData,
          title,
      }
  },
  head() {
      const head = header(this)
      return {
          ...head
      }
  },
});
